var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApiLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.3333C21.8409 23.3333 23.3333 21.8409 23.3333 20C23.3333 18.1591 21.8409 16.6667 20 16.6667C18.1591 16.6667 16.6667 18.1591 16.6667 20C16.6667 21.8409 18.1591 23.3333 20 23.3333Z",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.3333C10.8333 15 10 17.5 10 20C10 22.5 10.8333 25 12.5 26.6667",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10C5 12.5 3.33333 15.8333 3.33333 20C3.33333 24.1667 5 27.5 7.5 30",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 26.6667C29.1667 25 30 22.5 30 20C30 17.5 29.1667 15 27.5 13.3333",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30C35 27.5 36.6667 24.1667 36.6667 20C36.6667 15.8333 35 12.5 32.5 10",
    stroke: "#43D651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApiLocations);
export default __webpack_public_path__ + "static/media/icon_api_locations.17d41d51c49502c9820b01c277474098.svg";
export { ForwardRef as ReactComponent };